/*
  yapaycicekal.com — Be Yours 8.4.0 (v2)
  Tukenen urunler ("Load more" / infinite scroll) koleksiyonun MUTLAK sonuna atilir.
  Davranis: Tukenen kartlar sayfa parcalarindan cikarilip bir tamponda tutulur;
  son sayfa yuklendigi anda hepsi sirasi korunarak gridin sonuna eklenir.
  Gereksinim: <ul id="product-grid"> uzerinde data-yca-total="{{ collection.products_count }}"
  ve kartlarda .yca-sold-out class'i (iki gecisli Liquid dongusu).
*/
(() => {
  'use strict';

  const CONTAINER_ID = 'ProductGridContainer';
  const GRID_SELECTOR = '#product-grid';
  const ITEM_SELECTOR = 'li.flex-grid__item';
  const SOLD_OUT_SELECTOR = ':scope > .yca-sold-out';

  let state = { grid: null, buffer: [], done: false, busy: false };

  /* Tukenen bir kartin altinda stokta kart kaldi mi? (guvenlik kontrolu) */
  const needsMove = (grid) => {
    let seenSoldOut = false;
    for (const item of grid.children) {
      if (item.classList.contains('yca-sold-out')) seenSoldOut = true;
      else if (seenSoldOut) return true;
    }
    return false;
  };

  /* Tampondaki tukenen kartlari, yakalanma (koleksiyon) sirasiyla gridin sonuna ekle.
     Node'lar tasinir (clone edilmez) — quick add / quick view calismaya devam eder. */
  const flushBuffer = (grid) => {
    const fragment = document.createDocumentFragment();
    state.buffer.forEach((item) => fragment.appendChild(item));
    grid.appendChild(fragment);
    state.buffer = [];
  };

  const moveToEnd = (grid) => {
    if (!needsMove(grid)) return;
    const fragment = document.createDocumentFragment();
    grid.querySelectorAll(SOLD_OUT_SELECTOR).forEach((item) => fragment.appendChild(item));
    grid.appendChild(fragment);
  };

  /* Son sayfa mi? Birincil sinyal: yuklenen urun sayisi (grid + tampon) toplam sayiya ulasti.
     Yedek sinyal: container icinde "sonraki sayfa" linki kalmadi. */
  const isLastPage = (container, grid) => {
    const total = parseInt(grid.dataset.ycaTotal || '0', 10);
    const loaded =
      grid.querySelectorAll(':scope > ' + ITEM_SELECTOR).length + state.buffer.length;
    if (total > 0 && loaded >= total) return true;
    return !container.querySelector('a[href*="page="]');
  };

  const process = (container) => {
    const grid = container.querySelector(GRID_SELECTOR);
    if (!grid || state.busy) return;

    /* facets.js filtre/siralama sonrasi grid'i komple yeniden olusturur:
       yeni grid elementi = yeni sonuc kumesi, durumu sifirla. */
    if (grid !== state.grid) {
      state = { grid: grid, buffer: [], done: false, busy: false };
    }

    state.busy = true;

    if (state.done) {
      moveToEnd(grid);
    } else {
      grid.querySelectorAll(SOLD_OUT_SELECTOR).forEach((item) => {
        state.buffer.push(item);
        item.remove();
      });

      if (isLastPage(container, grid)) {
        state.done = true;
        if (state.buffer.length) flushBuffer(grid);
      }
    }

    requestAnimationFrame(() => {
      state.busy = false;
    });
  };

  /* Sadece grid'e yeni urun karti giren mutasyonlarla ilgilen
     (countdown metin guncellemeleri vb. gurultuyu ele). */
  const hasNewItems = (mutations) =>
    mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches(ITEM_SELECTOR) || node.querySelector(ITEM_SELECTOR))
      )
    );

  const init = () => {
    const container = document.getElementById(CONTAINER_ID);
    if (!container || container.dataset.ycaSortReady === 'true') return;
    container.dataset.ycaSortReady = 'true';

    const observer = new MutationObserver((mutations) => {
      if (state.busy || !hasNewItems(mutations)) return;
      requestAnimationFrame(() => process(container));
    });

    observer.observe(container, { childList: true, subtree: true });

    process(container);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Tema editoru: section yeniden yuklenince tekrar baslat. */
  document.addEventListener('shopify:section:load', () => init());
})();
